import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, X } from 'lucide-react';
interface FormSuccessPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
export function FormSuccessPopup({
  isOpen,
  onClose
}: FormSuccessPopupProps) {
  return <AnimatePresence data-id="element-186">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[9998] flex items-center justify-center" data-id="element-187" />

          {/* Popup */}
          <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 pointer-events-none" data-id="element-188">
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} transition={{
          type: 'spring',
          duration: 0.5
        }} className="w-full max-w-md pointer-events-auto" data-id="element-189">
              <div className="bg-white rounded-2xl p-8 shadow-2xl relative" data-id="element-190">
                {/* Close Button */}
                <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-191">
                  <X size={24} data-id="element-192" />
                </button>

                {/* Success Icon */}
                <motion.div initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} transition={{
              delay: 0.2,
              type: 'spring',
              stiffness: 200
            }} className="flex justify-center mb-6" data-id="element-193">
                  <div className="relative" data-id="element-194">
                    <div className="absolute inset-0 bg-primary/20 rounded-full blur-xl animate-pulse" data-id="element-195" />
                    <CheckCircle className="w-20 h-20 text-primary relative z-10" data-id="element-196" />
                  </div>
                </motion.div>

                {/* Content */}
                <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.3
            }} className="text-center" data-id="element-197">
                  <h3 className="text-2xl font-black text-black mb-3" data-id="element-198">
                    Form Submitted!
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-199">
                    Thank you for your interest! We will reach out to you within
                    the next{' '}
                    <span className="font-bold text-primary" data-id="element-200">24 hours</span>.
                  </p>
                  <button onClick={onClose} className="bg-primary text-white px-8 py-3 rounded-lg font-bold hover:bg-primary-dark transition-colors shadow-lg hover:shadow-xl" data-id="element-201">
                    Got It!
                  </button>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}